import { RECEIVE_KORE_SUBSCRIPTIONS, REQUEST_KORE_SUBSCRIPTION } from '@sophocles/entities/KoreSubscription/actions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_KORE_SUBSCRIPTIONS:
      return state.merge(action.subscriptions);
    case REQUEST_KORE_SUBSCRIPTION:
    default:
      return state;
  }
}

export function koreSubscriptionReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_KORE_SUBSCRIPTIONS:
    case REQUEST_KORE_SUBSCRIPTION:
      return getState(state, action);
    default:
      return state;
  }
}
